import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Box,
  CircularProgress,
  makeStyles,
  MenuItem
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import NumberFormat from "react-number-format";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import { format } from "date-fns";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import Slide from "@material-ui/core/Slide";
import axios from "axios";
import api from "../common/api";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const NumericInput = React.forwardRef((props, ref) => {
  const { onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={values => {
        onChange({
          target: {
            name: props.name,
            value: values.value
          }
        });
      }}
      thousandSeparator=","
      decimalSeparator="."
      decimalScale={2}
      fixedDecimalScale
      prefix="$"
    />
  );
});

const useStyles = makeStyles(theme => ({
  option: {
    fontSize: "0.75rem",
    minHeight: "auto",
    '&[aria-selected="true"]': {
      backgroundColor: "rgba(0, 0, 0, 0.08)"
    },
    '&[data-focus="true"]': {
      backgroundColor: "rgba(0, 0, 0, 0.04)"
    }
  },
  input: {
    fontSize: "0.75rem"
  }
}));

export default function CreditNote({ id, invoice_id, onClose, onSave }) {
  const classes = useStyles();
  const [invoiceLevels, setInvoiceLevels] = useState([]);
  const [tasks, setTasks] = useState({
    options: [],
    loading: false
  });
  const [clients, setClients] = useState({
    options: [],
    loading: false
  });
  const [credit_note, setCreditNote] = useState({
    id: id,
    invoice_id: invoice_id,
    invoice_point_of_sale_id: "",
    date: format(new Date(), "yyyy-MM-dd"),
    due_date: format(new Date(), "yyyy-MM-dd"),
    user_sales_id: "",
    pyme_invoice_type: "SDA",
    booking_id: "",
    client_id: null,
    item_total: 0,
    vat_total: 0,
    total: 0,
    auxiliary_invoice_code: "",
    tasks: [
      {
        task_id: null,
        name: "",
        quantity: 1,
        unit_price: 0,
        vat: 0,
        subtotal: 0
      }
    ]
  });

  const [invoice, setInvoice] = useState({
    id: invoice_id,
    invoice_type_id: "",
    invoice_point_of_sale_id: "",
    invoice_date: format(new Date(), "yyyy-MM-dd"),
    due_date: format(new Date(), "yyyy-MM-dd"),
    user_sales_id: "",
    pyme_invoice_type: "SDA",
    booking_id: "",
    client_id: null,
    item_total: 0,
    vat_total: 0,
    total: 0,
    tasks: [
      {
        task_id: null,
        name: "",
        quantity: 1,
        unit_price: 0,
        vat: 0,
        subtotal: 0
      }
    ]
  });
  const [invoiceTypes, setInvoiceTypes] = useState([]);
  const [pointOfSales, setPointOfSales] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [saving, setSaving] = useState(false);
  const [snackBar, setSnackBar] = useState({});

  const token = localStorage.getItem("userToken");

  const getCreditNote = async () => {
    try {
      const response = await axios.get(api.credit_notes().get(id), {
        headers: { Authorization: `Bearer ${token}` }
      });
      const credit_note_response = response.data.invoice;
      credit_note_response.tasks = response.data.invoice.items;
      if (credit_note_response.invoice) {
        credit_note_response.invoice_type_id =
          credit_note_response.invoice.invoice_type_id;
        credit_note_response.invoice_point_of_sale_id =
          credit_note_response.invoice.invoice_point_of_sale_id;
      }
      setCreditNote(credit_note_response);
    } catch (error) {
      console.error(error);
    }
  };
  const fetchInvoiceLevels = async () => {
    try {
      const response = await axios.get(api.invoice_levels, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (response.data) setInvoiceLevels(response.data.invoice_levels);
    } catch (error) {
      console.error(error);
    }
  };

  const getInvoice = async () => {
    try {
      const response = await axios.get(api.invoices().get(invoice_id), {
        headers: { Authorization: `Bearer ${token}` }
      });
      const tasks = response.data.invoice.invoice_tasks.map(task => {
        return {
          invoice_task_id: task.id ? task.id : null,
          task_id: task.task_id,
          name: task.task ? task.task.name : "",
          quantity: task.quantity,
          unit_price: task.unit_price,
          vat: task.vat,
          subtotal: task.subtotal,
          description: task.description,
          can_create_credit_note: task.can_create_credit_note
        };
      });

      let invoice_response = response.data.invoice;
      invoice_response.tasks = tasks;
      setInvoice(invoice_response);
      if (id == 0) {
        let credit_note_response = response.data.invoice;
        credit_note_response.tasks = tasks;
        credit_note_response.invoice_id = invoice_response.id;
        credit_note_response.id = 0;
        credit_note_response.due_date = format(new Date(), "yyyy-MM-dd");
        credit_note_response.date = format(new Date(), "yyyy-MM-dd");
        setCreditNote(credit_note_response);
        setSelectedClient(response.data.invoice.client);
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    getTasks();
    const fetchInvoiceTypes = async () => {
      try {
        const response = await axios.get(api.invoice_types, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setInvoiceTypes(response.data);
      } catch (error) {
        console.error(error);
      }
    };

    const fetchPointOfSales = async () => {
      try {
        const response = await axios.get(api.point_of_sales, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (response.data) setPointOfSales(response.data.points_of_sales);
      } catch (error) {
        console.error(error);
      }
    };
    fetchInvoiceTypes();
    fetchPointOfSales();
    fetchInvoiceLevels();
    if (invoice_id > 0) {
      getInvoice();
    } else {
      setCreditNote(prev => ({
        ...prev,
        tasks: [
          {
            task_id: null,
            name: "",
            quantity: 1,
            unit_price: 0,
            subtotal: 0
          }
        ]
      }));
    }
    if (id > 0) {
      getCreditNote();
    }
  }, []);

  const handleClientSearch = async (event, value) => {
    if (value.length > 2) {
      setClients(prev => ({ ...prev, loading: true }));
      const token = localStorage.getItem("userToken");
      try {
        const response = await axios.get(api.clients().autocomplete(value), {
          headers: { Authorization: `Bearer ${token}` }
        });
        setClients(prev => ({
          ...prev,
          options: response.data,
          loading: false
        }));
      } catch (error) {
        console.error(error);
        setClients(prev => ({ ...prev, loading: false }));
      }
    }
  };

  const handleClientChange = (event, value) => {
    setSelectedClient(value);
    setCreditNote(prev => ({
      ...prev,
      client_id: value ? value.id : null
    }));
  };
  const handleTaskChange = (index, field, value) => {
    const updatedTasks = [...credit_note.tasks];
    const task = updatedTasks[index];

    if (field === "quantity" || field === "unit_price") {
      const quantity = field === "quantity" ? value : task.quantity;
      const unitPrice = field === "unit_price" ? value : task.unit_price;
      const subtotal = quantity * unitPrice;

      task[field] = value;
      task.subtotal = subtotal;

      const newItemTotal = updatedTasks.reduce((sum, t) => sum + t.subtotal, 0);

      setCreditNote(prev => ({
        ...prev,
        tasks: updatedTasks,
        item_total: newItemTotal,
        total: newItemTotal
      }));
    } else if (
      field === "task_id" ||
      field === "name" ||
      field === "unit_price" ||
      field === "description"
    ) {
      task[field] = value;
      setInvoice(prev => ({
        ...prev,
        tasks: updatedTasks
      }));
    }
  };
  const getTasks = async () => {
    try {
      const response = await axios.get(
        api.work_order().tasks_autocomplete("", 1),
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );
      setTasks(prev => ({ ...prev, options: response.data, loading: false }));
    } catch (error) {
      console.error(error);
      setTasks(prev => ({ ...prev, loading: false }));
    }
  };

  const handleAddTask = () => {
    const newTask = {
      id: 0,
      task_id: "",
      name: "",
      quantity: 1,
      unit_price: 0,
      subtotal: 0
    };

    setCreditNote(prev => ({
      ...prev,
      tasks: [...prev.tasks, newTask]
    }));
  };

  const handleRemoveTask = index => {
    const taskToRemove = credit_note.tasks[index];
    const updatedTasks = credit_note.tasks.filter((_, i) => i !== index);

    // If this was the last task, add a new empty one
    if (updatedTasks.length === 0) {
      updatedTasks.push({
        task_id: null,
        name: "",
        quantity: 1,
        unit_price: 0,
        subtotal: 0
      });
    }

    const parseSubtotal = value => {
      if (typeof value === "number") return value;

      return parseFloat(value.replace(/\./g, "").replace(",", "."));
    };

    const newItemTotal = updatedTasks.reduce(
      (sum, t) => sum + parseSubtotal(t.subtotal),
      0
    );
    setCreditNote(prev => ({
      ...prev,
      tasks: updatedTasks,
      item_total: newItemTotal,
      total: newItemTotal
    }));
  };
  const handleSubmit = async () => {
    setSaving(true);
    var formData = new FormData();
    formData.append(
      "credit_note[invoice_id]",
      invoice_id > 0 ? invoice_id : ""
    );
    formData.append(
      "credit_note[point_of_sale_id]",
      credit_note.invoice_point_of_sale_id
        ? credit_note.invoice_point_of_sale_id
        : null
    );
    formData.append(
      "credit_note[date]",
      credit_note.date ? credit_note.date : null
    );
    formData.append(
      "credit_note[due_date]",
      credit_note.due_date ? credit_note.due_date : null
    );
    if (credit_note.client_id) {
      formData.append(
        "credit_note[client_id]",
        credit_note.client_id ? credit_note.client_id : null
      );
    }
    if (credit_note.level_1) {
      formData.append(
        "credit_note[level_1]",
        credit_note.level_1 ? credit_note.level_1 : null
      );
    }
    if (credit_note.level_2) {
      formData.append(
        "credit_note[level_2]",
        credit_note.level_2 ? credit_note.level_2 : null
      );
    }

    if (credit_note.auxiliary_invoice_code != "")
      formData.append(
        "credit_note[auxiliary_invoice_code]",
        credit_note.auxiliary_invoice_code
          ? credit_note.auxiliary_invoice_code
          : null
      );
    credit_note.tasks.forEach((task, index) => {
      formData.append(
        `tasks[${index}][invoice_task_id]`,
        task.invoice_task_id ? task.invoice_task_id : ""
      );
      formData.append(
        `tasks[${index}][description]`,
        task.description ? task.description : null
      );
      formData.append(
        `tasks[${index}][task_id]`,
        task.task_id ? task.task_id : null
      );
      formData.append(
        `tasks[${index}][quantity]`,
        task.quantity ? task.quantity : null
      );
      formData.append(
        `tasks[${index}][unit_price]`,
        task.unit_price ? task.unit_price : null
      );
    });

    let url = api.credit_notes().post();
    if (credit_note.id > 0) {
      url = api.credit_notes().patch(credit_note.id);
    }

    try {
      const response = await axios.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      });
      if (response.status === 200) {
        //setTask(response.data);
        setSnackBar({
          open: true,
          severity: "success",
          message: "Nota de crédito cargada correctamente"
        });
        setSelectedClient(null);
        if (response.data.id > 0) {
          setCreditNote(prev => ({
            ...prev,
            id: response.data.id
          }));
        }
        setSaving(false);
      }
    } catch (error) {
      let error_message = "Error al cargar la nota de crédito";
      if (error.response && error.response.data) {
        for (const key in error.response.data.errors) {
          error_message += ` ${error.response.data.errors[key]}`;
        }
      }
      if (error.response.data && error.response.data.sap_error)
        error_message = error.response.data.sap_error;
      console.error(error);
      setSnackBar({
        open: true,
        severity: "error",
        message: error_message
      });
    }
    setSaving(false);
  };
  return (
    <div>
      <Snackbar
        open={snackBar.open}
        onClose={value => setSnackBar({ ...snackBar, open: false })}
      >
        <Alert
          onClose={value => setSnackBar({ ...snackBar, open: false })}
          severity={snackBar.severity}
        >
          {snackBar.message}
        </Alert>
      </Snackbar>
      <div className="row mb-4">
        <div className="col-12 flex align-items-center d-flex justify-content-between">
          <Typography variant="h6">
            {credit_note.id == 0
              ? "Crear nota de crédito - " +
                (invoice.number ? invoice.number : "")
              : credit_note.number}
          </Typography>
          {credit_note.creator && (
            <span
              style={{
                padding: "2px 8px",
                borderRadius: "4px",
                backgroundColor: "red",
                fontSize: "0.6rem",
                color: "white",
                marginLeft: "10px"
              }}
            >
              Creado por: {credit_note.creator.name}
            </span>
          )}          
        </div>
      </div>
      <div className="row">
        {selectedClient && (
          <div className="col-md-2">
            <TextField
              fullWidth
              label="Cliente"
              type="text"
              value={selectedClient.business_name}
              disabled
              InputLabelProps={{
                shrink: true
              }}
              inputProps={{
                style: { fontSize: "0.75rem" }
              }}
            />
          </div>
        )}
        <div className="col-md-2">
          <TextField
            fullWidth
            label="Nro factura"
            type="text"
            value={invoice.number ? invoice.number : "Sin factura"}
            disabled
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{
              style: { fontSize: "0.75rem" }
            }}
          />
        </div>
        {!invoice.number && (
          <div className="col-md-2">
            <TextField
              type="text"
              name="auxiliary_invoice_code"
              value={credit_note.auxiliary_invoice_code}
              onChange={e =>
                setCreditNote({
                  ...credit_note,
                  auxiliary_invoice_code: e.target.value
                })
              }
              inputProps={{
                style: { fontSize: "0.75rem", width: "100px" }
              }}
              InputLabelProps={{
                shrink: true
              }}
              label="Nro SAP Auxiliar"
            />
          </div>
        )}
        <div className="col-md-2">
          <TextField
            value={invoice.total}
            disabled
            InputProps={{
              inputComponent: NumericInput
            }}
            inputProps={{
              style: { fontSize: "0.75rem", width: "100px" }
            }}
            InputLabelProps={{
              shrink: true
            }}
            label="Monto factura"
          />
        </div>
      </div>
      <div className="row mt-3">
        {invoice_id == 0 && (
          <div className="col-md-4">
            <Autocomplete
              options={clients.options}
              getOptionLabel={option => option.business_name}
              getOptionSelected={(option, value) => option.id === value.id}
              loading={clients.loading}
              onInputChange={handleClientSearch}
              onChange={handleClientChange}
              value={
                clients.options.find(
                  option => option.id === credit_note.client_id
                ) || null
              }
              autoComplete
              noOptionsText={
                <Typography variant="caption">Sin resultados</Typography>
              }
              includeInputInList
              classes={{
                option: classes.option
              }}
              renderInput={params => (
                <TextField
                  {...params}
                  label="Cliente"
                  fullWidth
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {clients.loading ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                    classes: {
                      input: classes.input
                    }
                  }}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              )}
            />
          </div>
        )}
        <div className="col-md-2">
          <TextField
            fullWidth
            label="Tipo de Factura"
            select
            disabled={invoice_id > 0}
            value={credit_note.invoice_type_id}
            onChange={e =>
              setCreditNote({ ...credit_note, invoice_type_id: e.target.value })
            }
            SelectProps={{
              native: true
            }}
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{
              style: { fontSize: "0.75rem" }
            }}
          >
            <option value="">Seleccionar tipo</option>
            {invoiceTypes.map(type => (
              <option key={type.id} value={type.id}>
                {type.name}
              </option>
            ))}
          </TextField>
        </div>
        <div className="col-md-2">
          <TextField
            fullWidth
            label="Punto de Venta"
            select
            disabled={invoice_id > 0}
            value={credit_note.invoice_point_of_sale_id}
            onChange={e =>
              setCreditNote({
                ...credit_note,
                invoice_point_of_sale_id: e.target.value
              })
            }
            SelectProps={{
              native: true
            }}
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{
              style: { fontSize: "0.75rem" }
            }}
          >
            <option value="">Seleccionar tipo</option>
            {pointOfSales.map(pos => (
              <option key={pos.id} value={pos.id}>
                {pos.name} ({pos.sap_code})
              </option>
            ))}
          </TextField>
        </div>
        <div className="col-md-2">
          <TextField
            fullWidth
            label="Fecha"
            type="date"
            value={credit_note.date}
            onChange={e =>
              setCreditNote({ ...credit_note, date: e.target.value })
            }
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{
              style: { fontSize: "0.75rem" }
            }}
          />
        </div>
        <div className="col-md-2">
          <TextField
            fullWidth
            label="Vencimiento"
            type="date"
            value={credit_note.due_date}
            onChange={e =>
              setCreditNote({ ...credit_note, due_date: e.target.value })
            }
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{
              style: { fontSize: "0.75rem" }
            }}
          />
        </div>
        {invoice_id == 0 && (
          <div className="col-md-3 mt-2">
            <TextField
              id="level_1"
              name="level_1"
              label="Agrupación 1"
              value={credit_note.level_1 || ""}
              onChange={e =>
                setCreditNote({ ...credit_note, level_1: e.target.value })
              }
              select
              fullWidth
              InputLabelProps={{
                shrink: true
              }}
              inputProps={{
                style: { fontSize: "0.75rem" }
              }}
              InputProps={{
                style: { fontSize: "0.75rem" }
              }}
            >
              <MenuItem value="" style={{ fontSize: "0.75rem" }}>
                Seleccione un nivel
              </MenuItem>
              {invoiceLevels
                .filter(i => i.level == 1)
                .map(level => (
                  <MenuItem
                    key={level.id}
                    value={level.id}
                    style={{ fontSize: "0.75rem" }}
                  >
                    {level.name}
                  </MenuItem>
                ))}
            </TextField>
          </div>
        )}
        {invoice_id == 0 && (
          <div className="col-md-3 mt-2">
            <TextField
              id="level_2"
              name="level_2"
              label="Agrupación 2"
              value={credit_note.level_2 || ""}
              onChange={e =>
                setCreditNote({ ...credit_note, level_2: e.target.value })
              }
              select
              fullWidth
              InputLabelProps={{
                shrink: true
              }}
              inputProps={{
                style: { fontSize: "0.75rem" }
              }}
              InputProps={{
                style: { fontSize: "0.75rem" }
              }}
            >
              <MenuItem value="" style={{ fontSize: "0.75rem" }}>
                Seleccione un nivel
              </MenuItem>
              {invoiceLevels
                .filter(i => i.level == 2)
                .map(level => (
                  <MenuItem
                    key={level.id}
                    value={level.id}
                    style={{ fontSize: "0.75rem" }}
                  >
                    {level.name}
                  </MenuItem>
                ))}
            </TextField>
          </div>
        )}
      </div>

      <div className="row mt-3">
        <div className="col-12">
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Tarea</TableCell>
                  <TableCell align="left">Descripción</TableCell>
                  <TableCell align="right">Cantidad</TableCell>
                  <TableCell align="right">Precio Unitario S/IVA</TableCell>
                  <TableCell align="right">Subtotal S/IVA</TableCell>
                  <TableCell align="right"></TableCell>
                  <TableCell align="right">
                    <Box display="flex" justifyContent="flex-end">
                      <IconButton
                        color="primary"
                        onClick={handleAddTask}
                        size="small"
                      >
                        <AddIcon />
                      </IconButton>
                    </Box>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {credit_note &&
                  credit_note.tasks &&
                  credit_note.tasks.map((task, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        {credit_note.id > 0 ? (
                          <Typography variant="caption">{task && task.task ? task.task.sap_code + " - " + task.task.name : ""}</Typography>
                        ) : (
                          <TextField
                            id={`task-${index}`}
                            value={task.task_id || ""}
                            onChange={e =>
                              handleTaskChange(index, "task_id", e.target.value)
                            }
                            select
                            placeholder="Ingrese una tarea"
                            InputProps={{
                              style: { fontSize: "0.75rem", maxWidth: "200px" }
                            }}
                            InputLabelProps={{
                              shrink: true
                            }}
                          >
                            <MenuItem value="" style={{ fontSize: "0.75rem" }}>
                              Seleccione una tarea
                            </MenuItem>
                            {tasks.options.map(option => (
                              <MenuItem
                                key={option.id}
                                value={option.id}
                                style={{ fontSize: "0.75rem" }}
                              >
                                {option.name}
                              </MenuItem>
                            ))}
                          </TextField>
                        )}
                      </TableCell>
                      <TableCell align="right">
                        <TextField
                          type="text"
                          fullWidth
                          value={task.description ? task.description : ""}
                          disabled={
                            !task.can_create_credit_note && invoice_id > 0
                          }
                          onChange={e =>
                            handleTaskChange(
                              index,
                              "description",
                              e.target.value
                            )
                          }
                          InputProps={{
                            style: { fontSize: "0.75rem", minWidth: 400 }
                          }}
                          InputLabelProps={{
                            shrink: true
                          }}
                        />
                      </TableCell>

                      <TableCell align="right">
                        <TextField
                          type="number"
                          disabled={
                            !task.can_create_credit_note && invoice_id > 0
                          }
                          value={task.quantity}
                          onChange={e =>
                            handleTaskChange(
                              index,
                              "quantity",
                              parseFloat(e.target.value)
                            )
                          }
                          inputProps={{
                            min: 1,
                            style: { fontSize: "0.75rem", width: "60px" }
                          }}
                          InputLabelProps={{
                            shrink: true
                          }}
                        />
                      </TableCell>
                      <TableCell align="right">
                        <TextField
                          value={task.unit_price}
                          disabled={
                            !task.can_create_credit_note && invoice_id > 0
                          }
                          onChange={e =>
                            handleTaskChange(
                              index,
                              "unit_price",
                              parseFloat(e.target.value)
                            )
                          }
                          InputProps={{
                            inputComponent: NumericInput
                          }}
                          inputProps={{
                            style: { fontSize: "0.75rem", width: "100px" }
                          }}
                          InputLabelProps={{
                            shrink: true
                          }}
                        />{" "}
                      </TableCell>
                      <TableCell align="right">
                        <NumberFormat
                          value={task.subtotal}
                          displayType="text"
                          thousandSeparator=","
                          decimalSeparator="."
                          decimalScale={2}
                          fixedDecimalScale
                          prefix=""
                          style={{ fontSize: "0.75rem" }}
                        />
                      </TableCell>
                      <TableCell align="right">
                        <IconButton
                          onClick={() => handleRemoveTask(index)}
                          size="small"
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-12">
          <Box display="flex" justifyContent="flex-end">
            <Box mr={2}>
              <Typography variant="subtitle2">
                Total:{" "}
                <NumberFormat
                  value={credit_note.total}
                  displayType="text"
                  thousandSeparator=","
                  decimalSeparator="."
                  decimalScale={2}
                  fixedDecimalScale
                  prefix="$"
                />
              </Typography>
            </Box>
          </Box>
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-12">
          <Button onClick={onClose} color="secondary" size="small">
            {credit_note.id == 0 ? "Cancelar" : "Volver"}
          </Button>
          {credit_note.id == 0 &&
            (invoice.can_create_credit_note || invoice_id == 0) && (
              <Button
                onClick={handleSubmit}
                color="primary"
                variant="contained"
                disabled={saving}
                size="small"
              >
                Guardar
              </Button>
            )}
        </div>
      </div>
    </div>
  );
}
